import { createBasicLoopbackRepository } from 'elentari'
import { paginate, query } from '../../lib/loopback'

import { restApi } from '../../services/Api'

const MensagemRepository = createBasicLoopbackRepository({
  path: 'mensagens',
  queryTransform: {
    mensagem: query.ilike('mensagem'),
    ...paginate
  },
  restApi
})

export default MensagemRepository
